import { useEffect } from "react";
import { AppUpdate, AppUpdateAvailability, AppUpdateResult, AppUpdateResultCode } from "@capawesome/capacitor-app-update";
import { Capacitor } from "@capacitor/core";
import { useIonAlert } from "@ionic/react";

export const useUpdate = () => {
  const [presentAlert] = useIonAlert();

  const openAppStore = async () => {
    await AppUpdate.openAppStore();
  };

  const performImmediateUpdate = async () => {
    const result = await AppUpdate.getAppUpdateInfo();
    if (result.updateAvailability === AppUpdateAvailability.UPDATE_NOT_AVAILABLE) {
      return;
    }
    if (result.immediateUpdateAllowed) {
      const immediateUpdateResult: AppUpdateResult = await AppUpdate.performImmediateUpdate();
      if (immediateUpdateResult.code === AppUpdateResultCode.OK) {
        window.location.reload();
      }
    }
  };

  const handleCheckUpdate = async () => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const result = await AppUpdate.getAppUpdateInfo();

    if (result.updateAvailability === AppUpdateAvailability.UPDATE_NOT_AVAILABLE) {
      return;
    }

    presentAlert({
      message: "Elérhető egy új verzió. Kérjük, frissítse az alkalmazást.",
      buttons: [
        {
          text: "Mégse",
          role: "cancel",
        },
        {
          text: "Frissítés",
          handler: () => {
            if (result.immediateUpdateAllowed) {
              performImmediateUpdate();
              return;
            }
            openAppStore();
          },
        },
      ],
    });
  };

  useEffect(() => {
    handleCheckUpdate();
  }, []);
};
